import Logout from "@components/Logout";
import ROUTES from "@constants/routing";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface NavigationButtonsProps {
  disabled: boolean;
  onGoBack?: () => void;
}

const NavigationButtons = ({ disabled, onGoBack }: NavigationButtonsProps) => {
  const navigate = useNavigate();

  const onGoBackHome = () => {
    navigate(ROUTES.ADMIN_PANEL);
  };

  return (
    <Box className=" w-full flex justify-between">
      <Box className="justify-start">
        <IconButton
          color="info"
          style={{ backgroundColor: "white" }}
          onClick={onGoBack || onGoBackHome}
          disabled={disabled}
        >
          <ArrowBackIosNewIcon />
        </IconButton>
      </Box>
      <Box className="justify-end">
        <Logout disabled={disabled} />
      </Box>
    </Box>
  );
};

export default NavigationButtons;
